import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 查询优惠券列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回优惠券列表
 */
export function listShopCoupon(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/coupon.queryShopCoupon',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加优惠券
 * @param {Object} data 优惠券数据
 * @returns {Promise} 返回操作结果
 */
export function saveShopCoupon(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/coupon.saveShopCoupon',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新优惠券
 * @param {Object} data 优惠券数据
 * @returns {Promise} 返回操作结果
 */
export function updateShopCoupon(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/coupon.updateShopCoupon',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除优惠券
 * @param {Object} data 删除参数
 * @returns {Promise} 返回操作结果
 */
export function deleteShopCoupon(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/coupon.deleteShopCoupon',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 赠送优惠券
 * @param {Object} data 赠送数据 {couponId, tel}
 * @returns {Promise} 返回操作结果
 */
export function giveCoupon(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/coupon.giveCoupon',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询用户优惠券列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回用户优惠券列表
 */
export function listUserCoupon(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/coupon.queryUserCoupon',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询赠送优惠券记录列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回赠送记录列表
 */
export function listCouponGiveLog(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/coupon.queryCouponGiveLog',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询领取优惠券记录列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回领取记录列表
 */
export function listCouponReceiveLog(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/coupon.queryCouponReceiveLog',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询使用优惠券记录列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回使用记录列表
 */
export function listCouponUseLog(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/coupon.queryCouponUseLog',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 根据手机号查询用户
 * @param {Object} params 查询参数 {tel}
 * @returns {Promise} 返回用户信息
 */
export function queryUserByTel(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.queryShopTelUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询平台优惠券列表（运营端，无 shopId 维度；statusCd 由调用方决定，不传后端默认只回在架券）
 * @param {Object} params 查询参数
 * @returns {Promise} 返回平台优惠券列表
 */
export function listPlatformCoupon(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/coupon.queryPlatformCoupon',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加平台优惠券（运营端，无 shopId 维度）
 * @param {Object} data 平台优惠券数据
 * @returns {Promise} 返回操作结果
 */
export function savePlatformCoupon(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/coupon.savePlatformCoupon',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新平台优惠券（运营端，无 shopId 维度）
 * @param {Object} data 平台优惠券数据
 * @returns {Promise} 返回操作结果
 */
export function updatePlatformCoupon(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/coupon.updatePlatformCoupon',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除平台优惠券（运营端，无 shopId 维度）
 * @param {Object} data 删除参数 {couponId}
 * @returns {Promise} 返回操作结果
 */
export function deletePlatformCoupon(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/coupon.deletePlatformCoupon',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 平台优惠券上架/下架（运营端，无 shopId 维度）
 * @param {Object} data 上下架参数 {couponId, state}
 * @returns {Promise} 返回操作结果
 */
export function shelfPlatformCoupon(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/coupon.shelfPlatformCoupon',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询平台优惠券领取记录列表（运营端，无 shopId 维度，固定查平台券）
 * @param {Object} params 查询参数
 * @returns {Promise} 返回平台券领取记录列表
 */
export function listPlatformCouponReceiveLog(params) {
  return new Promise((resolve, reject) => {
    params.couponBelong = 'PLATFORM'
    request({
      url: '/coupon.queryCouponReceiveLog',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询平台优惠券使用记录列表（运营端，无 shopId 维度，固定查平台券）
 * @param {Object} params 查询参数
 * @returns {Promise} 返回平台券使用记录列表
 */
export function listPlatformCouponUseLog(params) {
  return new Promise((resolve, reject) => {
    params.couponBelong = 'PLATFORM'
    request({
      url: '/coupon.queryCouponUseLog',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

